import { Injectable } from '@angular/core';
import { MatomoTracker } from 'ngx-matomo-client';
import { environment } from '../../environments/local/environment';
import {OmsDetectorDataEntry} from "../models/oms-detector-data-entry";

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  constructor(private MatomoTracker: MatomoTracker) {}

  goToLink(link: string) {
    this.MatomoTracker.trackLink(link, 'link');
    window.open(link, '_blank', 'noopener,noreferrer');
  }

  openAppUrlInNewTab(relativePath: string) {
    const link = environment.redirect.host + relativePath;
    this.goToLink(link);
  }
  isNS_ERROR(e: Error) {
    return e.name === 'NS_ERROR_FAILURE';
  }

  /**
   * Formats the oms key production date representation (YYYY-MM-DD) into a more user-friendly representation
   */
  formatDate(omsKeyProductionDate: string): string {
    return omsKeyProductionDate.split("-").reverse().join(".");
  }
}
